export const ERROR_MESSAGE =
  'При отправке запроса произошла ошибка. Пожалуйста, попробуйте позже или обратитесь в техническую поддержку.';

export const STATEMENT_MESSAGE =
  'Ваше заявление принято и рассмотрено автоматически, теперь вы можете подать заявление на начисление номинала на сертификат.';
export const NOMINAL_MESSAGE =
  'Ваше заявление принято и рассмотрено автоматически, теперь вы можете выбрать подходящие программы.';
export const STATEMENT_BTN_TEXT = 'Все понятно';
export const NOMINAL_BTN_TEXT = 'Перейти в каталог';



// WEBPACK FOOTER //
// ./src/pages/profile/views/certificate/const.ts